const ExternalIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

interface Project {
  href: string;
  name: string;
  url: string;
  industry: string;
  desc: string;
  tags: string[];
  delay: string;
  accentColor: string;
}

const PROJECTS: Project[] = [
  {
    href: 'https://icfhouse.sk',
    name: 'ICF House',
    url: 'icfhouse.sk',
    industry: 'Stavebníctvo',
    desc: 'Moderná prezentácia stavebnej firmy s katalógom projektov, dôrazom na dôveryhodnosť a generáciu dopytov.',
    tags: ['React', 'TypeScript'],
    delay: '',
    accentColor: '#FF4500',
  },
  {
    href: 'https://boxynosice.sk',
    name: 'Boxy Nosiče',
    url: 'boxynosice.sk',
    industry: 'Automotive',
    desc: 'E-shop s boxmi a nosičmi na autá s vlastným rezervačným systémom a správou skladových zásob.',
    tags: ['WordPress', 'Custom PHP', 'WooCommerce'],
    delay: ' delay-1',
    accentColor: '#2463FF',
  },
  {
    href: 'https://salonsirka.sk',
    name: 'Salón Sirka',
    url: 'salonsirka.sk',
    industry: 'Krása & Wellness',
    desc: 'Elegantný web kozmetického salóna s online rezervačným systémom, galériou prác a cenníkom.',
    tags: ['React', 'Tailwind'],
    delay: ' delay-2',
    accentColor: '#c026d3',
  },
  {
    href: 'https://greys.sk',
    name: 'MUDr. Sivák',
    url: 'greys.sk',
    industry: 'Zdravotníctvo',
    desc: 'Profesionálna prezentácia zubného chirurga s dôrazom na dôveru pacientov a jednoduchú navigáciu.',
    tags: ['WordPress', 'Elementor'],
    delay: ' delay-3',
    accentColor: '#0ea5e9',
  },
  {
    href: 'https://petermotyl.sk',
    name: 'Peter Motýľ',
    url: 'petermotyl.sk',
    industry: 'Financie',
    desc: 'Osobný brand finančného poradcu. Generácia leadov, blog s radami a jednoduché kontaktovanie cez formulár.',
    tags: ['WordPress', 'SEO'],
    delay: ' delay-4',
    accentColor: '#16a34a',
  },
  {
    href: 'https://meridia.sk',
    name: 'Meridia',
    url: 'meridia.sk',
    industry: 'Biznis & Consulting',
    desc: 'Firemný web s dôrazom na profesionalitu, prezentáciu tímu a generáciu B2B dopytov.',
    tags: ['Web', 'Custom Design'],
    delay: ' delay-4',
    accentColor: '#7c3aed',
  },
];

function ProjectThumb({ p }: { p: Project }) {
  return (
    <div className="portfolio-thumb" aria-hidden="true">
      <div
        className="portfolio-thumb-bg"
        style={{
          background: `linear-gradient(135deg, #080810 0%, color-mix(in srgb, ${p.accentColor} 18%, #080810) 100%)`,
        }}
      />
      {/* Decorative grid lines */}
      <div className="portfolio-thumb-grid" />
      {/* Domain name overlay */}
      <div className="portfolio-thumb-content">
        <div
          className="portfolio-thumb-dot"
          style={{ background: p.accentColor }}
        />
        <span className="portfolio-thumb-url">{p.url}</span>
        <div
          className="portfolio-thumb-bar"
          style={{ background: p.accentColor }}
        />
        <div className="portfolio-thumb-lines">
          <div className="portfolio-thumb-line" />
          <div className="portfolio-thumb-line portfolio-thumb-line--short" />
        </div>
      </div>
      {/* Corner badge */}
      <div
        className="portfolio-thumb-badge"
        style={{ background: `${p.accentColor}22`, borderColor: `${p.accentColor}44`, color: p.accentColor }}
      >
        {p.industry}
      </div>
    </div>
  );
}

export default function Portfolio() {
  return (
    <section id="projekty" aria-labelledby="projekty-heading">
      <div className="container">
        <div className="section-header">
          <span className="section-tag fade-up">Projekty</span>
          <h2 id="projekty-heading" className="section-h2 fade-up delay-1">
            Reálne <span className="grad">výsledky</span>
          </h2>
          <p className="section-sub fade-up delay-2">
            Projekty, na ktoré sme hrdí. Každý jeden riešil skutočný problém skutočného biznisu.
          </p>
        </div>
        <div className="portfolio-grid">
          {PROJECTS.map((p) => (
            <a
              key={p.href}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`portfolio-card fade-up${p.delay}`}
            >
              <ProjectThumb p={p} />
              <div className="portfolio-header">
                <div>
                  <div className="portfolio-name">{p.name}</div>
                  <div className="portfolio-url">{p.url}</div>
                </div>
                <div className="portfolio-link-icon" aria-hidden="true">
                  <ExternalIcon />
                </div>
              </div>
              <span className="portfolio-industry">{p.industry}</span>
              <p className="portfolio-desc">{p.desc}</p>
              <div className="portfolio-stack">
                {p.tags.map((t) => <span key={t} className="tag">{t}</span>)}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
